import { ReactNode } from "react"
import { Navigate, useLocation } from "react-router-dom"
import { Box, CircularProgress, Typography } from "@mui/material"
import { useAuth } from "../hooks/useAuth"
import NoOrganizationAccess from "./NoOrganizationAccess"

interface ProtectedRouteProps {
  children: ReactNode
}

function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth()
  const activeOrgId = user?.active_org?.uuid[0]?.value
  const location = useLocation()

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          gap: 2,
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" color="textSecondary">
          Loading...
        </Typography>
      </Box>
    )
  }

  if (!isAuthenticated) {
    // Redirect to login page while saving the location they were trying to access
    return <Navigate to="/login" state={{ from: location.pathname }} replace />
  }

  if (!activeOrgId) {
    return <NoOrganizationAccess />
  }

  return <>{children}</>
}

export default ProtectedRoute
